import { RouteRecordRaw } from 'vue-router';
import { requireAuth, setDayjsTimezone } from '@/common/router/authGuard';
import { ROLE_PERMISSION_KEY } from '@/common/define/rolePermission.define';
import { extractAccessibleRoutes } from '@/common/auth/auth.utils';
import BaseViewport from '@/common/components/templates/baseViewport/BaseViewport.vue';
import { VIEWPORT_TYPE } from '@/common/components/templates/baseViewport/baseViewport.define';

const PREFIX_REPORT = 'report_';

const reportMenu: RouteRecordRaw[] = [
  {
    path: '/report/',
    name: `${PREFIX_REPORT}Report`,
    component: BaseViewport,
    beforeEnter: [requireAuth, setDayjsTimezone],
    meta: {
      rolePermission: ROLE_PERMISSION_KEY.MONITORING.MONITORING_REPORT,
      viewport: VIEWPORT_TYPE.REALTIME,
    },
    children: [
      {
        path: 'history',
        name: `${PREFIX_REPORT}Report History`,
        component: () => import('../views/historyView/HistoryView.vue'),
        meta: {
          rolePermission: ROLE_PERMISSION_KEY.MONITORING.MONITORING_REPORT_ALERT_HISTORY,
        },
      },
      {
        path: 'dashboard-export',
        name: `${PREFIX_REPORT}Dashboard Export`,
        component: () => import('../views/dashboardExport/DashboardExport.vue'),
        meta: {
          rolePermission: ROLE_PERMISSION_KEY.MONITORING.MONITORING_DASHBOARD_REPORT_EXPORT,
        },
      },
      {
        path: 'export-business',
        name: `${PREFIX_REPORT}Export Business`,
        component: () => import('../views/businessExport/BusinessExport.vue'),
        meta: {
          rolePermission: ROLE_PERMISSION_KEY.MONITORING.MONITORING_BUSINESS_REPORT_EXPORT,
        },
      },
    ],
  },
];

const getReportNaviMenu = (subMenu?: 'report') => {
  const filteredReportMenu = extractAccessibleRoutes(reportMenu);

  if (subMenu === 'report') return filteredReportMenu.slice(0, 1);
  return [...filteredReportMenu];
};

export { reportMenu, getReportNaviMenu };
